(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1487],{

/***/ 16339:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/u/[username]/post/[[...status]]",
      function () {
        return __webpack_require__(55008);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 99117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ usePrincipal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _tidb_community_datasource__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70780);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8100);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62675);




var usePrincipalSsr = function() {
    return {
        loading: false,
        id: undefined,
        authorities: [],
        roles: [],
        hasAuthority: function() {
            return false;
        },
        hasRole: function() {
            return false;
        },
        isAuthor: function() {
            return false;
        },
        isLogin: false
    };
};
var UNAUTHORIZED = {
    id: undefined,
    roles: [],
    authorities: []
};
var usePrincipalBrowser = function() {
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context__WEBPACK_IMPORTED_MODULE_2__/* .MeContext */ .io), meData = ref3.meData, isMeValidating = ref3.isMeValidating;
    var ref1 = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)([
        meData === null || meData === void 0 ? void 0 : meData.username
    ], {
        fetcher: function() {
            return _tidb_community_datasource__WEBPACK_IMPORTED_MODULE_3__.principal();
        }
    }), principal = ref1.data;
    var ref2 = principal !== null && principal !== void 0 ? principal : UNAUTHORIZED, id = ref2.id, roles = ref2.roles, authorities = ref2.authorities;
    var hasRole = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(auth) {
        return roles.indexOf(auth) >= 0;
    }, [
        roles
    ]);
    var hasAuthority = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(auth) {
        return authorities.indexOf(auth) >= 0;
    }, [
        authorities
    ]);
    var isAuthor = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(target) {
        var ref;
        return id !== undefined && (target === null || target === void 0 ? void 0 : (ref = target.author) === null || ref === void 0 ? void 0 : ref.id) === id;
    }, [
        id
    ]);
    var isLogin = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return typeof id === "number";
    }, [
        id
    ]);
    // TODO: some thing not correct with principal.isValidating
    var loading = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (meData) {
            return isMeValidating || typeof (principal === null || principal === void 0 ? void 0 : principal.id) === "undefined";
        } else {
            return isMeValidating;
        }
    }, [
        meData,
        principal,
        isMeValidating
    ]);
    return {
        roles: roles,
        authorities: authorities,
        hasRole: hasRole,
        hasAuthority: hasAuthority,
        isAuthor: isAuthor,
        isLogin: isLogin,
        id: id,
        loading: loading
    };
};
var usePrincipal =  false ? 0 : usePrincipalBrowser;


/***/ }),

/***/ 55008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ ProfilePostPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/pages/u/[username]/common.styled.ts
var common_styled = __webpack_require__(82012);
// EXTERNAL MODULE: ./src/pages/u/[username]/_components/Tab/index.tsx + 1 modules
var Tab = __webpack_require__(90568);
// EXTERNAL MODULE: ./src/pages/u/[username]/_components/ProfileLayout/index.tsx + 5 modules
var ProfileLayout = __webpack_require__(78468);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js
var divider = __webpack_require__(27049);
// EXTERNAL MODULE: ./node_modules/antd/es/list/index.js + 1 modules
var list = __webpack_require__(95507);
// EXTERNAL MODULE: ./node_modules/antd/es/space/index.js + 1 modules
var space = __webpack_require__(26713);
// EXTERNAL MODULE: ./src/pages/u/[username]/_components/ListItem/index.tsx + 1 modules
var ListItem = __webpack_require__(53662);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/EyeOutlined.js + 1 modules
var EyeOutlined = __webpack_require__(99611);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/HeartOutlined.js + 1 modules
var HeartOutlined = __webpack_require__(49647);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/MessageOutlined.js + 1 modules
var MessageOutlined = __webpack_require__(38545);
// EXTERNAL MODULE: ./src/utils/datetime.utils.ts
var datetime_utils = __webpack_require__(11093);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
// EXTERNAL MODULE: ./src/api/blog/index.ts
var blog = __webpack_require__(865);
// EXTERNAL MODULE: ./src/components/EmptyStatus/index.tsx + 1 modules
var EmptyStatus = __webpack_require__(48556);
// EXTERNAL MODULE: ./src/pages/u/[username]/constant.data.ts
var constant_data = __webpack_require__(48956);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./node_modules/swr/infinite/dist/index.mjs
var dist = __webpack_require__(44593);
;// CONCATENATED MODULE: ./src/pages/u/[username]/post/post-info.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var infos = [
    {
        path: "all",
        status: "",
        statusText: "\u53D1\u8868\u8FC7\u4EFB\u4F55",
        showBadge: true
    },
    {
        path: "draft",
        status: "DRAFT",
        statusText: "\u8349\u7A3F\u72B6\u6001\u7684"
    },
    {
        path: "pending",
        status: "PENDING",
        statusText: "\u5BA1\u6838\u4E2D\u7684"
    },
    {
        path: "rejected",
        status: "REJECTED",
        statusText: "\u5BA1\u6838\u672A\u901A\u8FC7\u7684"
    },
    {
        path: undefined,
        status: "PUBLISHED",
        statusText: "\u53D1\u8868\u8FC7\u4EFB\u4F55"
    }, 
];
// maps /blog/user/:id/posts => published
// maps /blog/user/:id/posts/{all,pending,draft,rejected}
// type is from slug
var getPageInfo = function(typeParam) {
    if ((typeParam === null || typeParam === void 0 ? void 0 : typeParam.length) > 1) {
        return undefined;
    }
    var ref = _slicedToArray(typeParam || [], 1), path = ref[0];
    return infos.find(function(info) {
        return info.path === path;
    });
};

// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js + 44 modules
var es_select = __webpack_require__(18963);
;// CONCATENATED MODULE: ./src/pages/u/[username]/post/StatusSelect.component.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var statuses = [
    {
        label: "\u5168\u90E8",
        value: "",
        url: "all"
    },
    {
        label: "\u5DF2\u53D1\u5E03",
        value: "PUBLISHED",
        url: ""
    },
    {
        label: "\u8349\u7A3F",
        value: "DRAFT",
        url: "draft"
    },
    {
        label: "\u5BA1\u6838\u4E2D",
        value: "PENDING",
        url: "pending"
    },
    {
        label: "\u5BA1\u6838\u672A\u901A\u8FC7",
        value: "REJECTED",
        url: "rejected"
    }, 
];
function StatusSelect(_param) {
    var shallow = _param.shallow, props = _objectWithoutProperties(_param, [
        "shallow"
    ]);
    var router = (0,next_router.useRouter)();
    var username = router.query.username;
    var onChangeFilter = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(value, option) {
            var url, newUrl;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        url = option.url;
                        newUrl = "/u/".concat(encodeURIComponent(username), "/post/").concat(url);
                        _ctx.next = 4;
                        return router.push(newUrl, newUrl, {
                            shallow: shallow !== null && shallow !== void 0 ? shallow : false
                        });
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onChangeFilter(value, option) {
            return _ref.apply(this, arguments);
        };
    }();
    //@ts-ignore
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, _objectSpread({
        style: {
            width: "8rem"
        },
        options: statuses,
        onChange: onChangeFilter
    }, props));
};

// EXTERNAL MODULE: ./src/pages/blog/blog.hooks.js
var blog_hooks = __webpack_require__(99117);
// EXTERNAL MODULE: ./src/context/index.js + 3 modules
var context = __webpack_require__(62675);
;// CONCATENATED MODULE: ./src/pages/u/[username]/post/[[...status]].page.tsx
function _status_page_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _status_page_arrayLikeToArray(arr);
}
function _status_page_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _status_page_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                _status_page_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                _status_page_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _status_page_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _status_page_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _status_page_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _status_page_arrayLikeToArray(o, minLen);
}



// import * as Styled from './index.styled';



















var pageSize = 20;
var __N_SSP = true;
function ProfilePostPage(props) {
    var _posts;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var badges = props.badges, profile = props.profile, summary = props.summary, postsFromSSR = props.posts, postFavoritesNumber = props.postFavoritesNumber;
    var ref6;
    var askTugFavoritesNumber = (ref6 = summary === null || summary === void 0 ? void 0 : (ref = summary.user_summary) === null || ref === void 0 ? void 0 : ref.bookmark_count) !== null && ref6 !== void 0 ? ref6 : 0;
    var allFavoritesNumber = askTugFavoritesNumber + (postFavoritesNumber !== null && postFavoritesNumber !== void 0 ? postFavoritesNumber : 0);
    var router = (0,next_router.useRouter)();
    var _query = router.query, status = _query.status, username = _query.username;
    var pageInfo = getPageInfo(status);
    var hasAuthority = (0,blog_hooks/* usePrincipal */.j)().hasAuthority;
    var meData = (0,react.useContext)(context/* MeContext */.io).meData;
    var showFilter = (meData === null || meData === void 0 ? void 0 : meData.username) === username || hasAuthority("READ_OTHERS_POST");
    var tabExtendDOM = showFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusSelect, {
        value: pageInfo.status,
        shallow: true
    });
    var isShowStatusBadge = pageInfo.status === "" && showFilter;
    var getKey = function(page) {
        return [
            "blog.username.getPostsByUsername",
            {
                status: pageInfo.status,
                username: username,
                page: page,
                size: pageSize
            }
        ];
    };
    var ref7 = (0,dist/* default */.ZP)(getKey, {
        fallbackData: [
            postsFromSSR
        ],
        revalidateOnMount: true
    }), postsResp = ref7.data, postsError = ref7.error, size1 = ref7.size, setSize = ref7.setSize, mutate = ref7.mutate;
    (0,react.useEffect)(function() {
        mutate(function() {
            return [];
        }, false).then();
    }, [
        mutate,
        pageInfo.status
    ]);
    var error = postsError;
    var loading = !postsResp;
    if (error) return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ErrorPage */.mf, {
        statusCode: 500,
        errorMsg: "\u6682\u65F6\u65E0\u6CD5\u83B7\u53D6\u4E13\u680F\u6570\u636E\uFF0C\u8BF7\u7A0D\u5019\u518D\u8BD5"
    });
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
        active: true
    });
    var loadMoreData = function() {
        var _ref = _status_page_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return setSize(function(size) {
                            return size + 1;
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadMoreData() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref8;
    var hasMore = (ref8 = ((ref1 = postsResp[0]) === null || ref1 === void 0 ? void 0 : ref1.page.totalPages) > size1) !== null && ref8 !== void 0 ? ref8 : false;
    var posts = [];
    postsResp.forEach(function(param) {
        var content = param.content;
        return (_posts = posts).push.apply(_posts, _toConsumableArray(content));
    });
    var isEmpty = loading === false && posts.length === 0;
    var postsNumber = (0,blog.getListNumberFromResponse)(postsResp[0]);
    var ref9, ref10, ref11, ref12;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfileLayout/* default */.Z, {
        badges: badges,
        profile: profile,
        nums: {
            like: (ref9 = summary === null || summary === void 0 ? void 0 : (ref2 = summary.user_summary) === null || ref2 === void 0 ? void 0 : ref2.likes_received) !== null && ref9 !== void 0 ? ref9 : 0,
            answer: (ref10 = summary === null || summary === void 0 ? void 0 : (ref3 = summary.user_summary) === null || ref3 === void 0 ? void 0 : ref3.post_count) !== null && ref10 !== void 0 ? ref10 : 0,
            post: postsNumber
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_styled/* Action */.aU, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                    selected: Tab/* EUgcType.post */.$.post,
                    nums: {
                        answer: (ref11 = summary === null || summary === void 0 ? void 0 : (ref4 = summary.user_summary) === null || ref4 === void 0 ? void 0 : ref4.post_count) !== null && ref11 !== void 0 ? ref11 : 0,
                        question: (ref12 = summary === null || summary === void 0 ? void 0 : (ref5 = summary.user_summary) === null || ref5 === void 0 ? void 0 : ref5.topic_count) !== null && ref12 !== void 0 ? ref12 : 0,
                        post: postsNumber,
                        favorite: allFavoritesNumber
                    },
                    extendDom: tabExtendDOM
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_styled/* List */.aV, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                    dataLength: posts.length,
                    next: loadMoreData,
                    hasMore: hasMore,
                    loader: loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginTop: "16px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                            avatar: true,
                            paragraph: {
                                rows: 1
                            },
                            active: true
                        })
                    }),
                    endMessage: posts.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* default */.Z, {
                        plain: true,
                        children: "\u6CA1\u6709\u66F4\u591A\u5185\u5BB9\u4E86"
                    }),
                    children: isEmpty ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyStatus/* default */.Z, {
                        description: "\u4F60\u8FD8\u6CA1\u6709".concat(pageInfo.statusText, "\u6587\u7AE0"),
                        children: [
                            "\u5FEB\u524D\u5F80 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: constant_data/* blogUrl */.O,
                                children: "\u3010\u793E\u533A\u4E13\u680F\u3011"
                            }),
                            " \u64B0\u5199\u6280\u672F\u6587\u7AE0\u5427\uFF5E"
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* default */.ZP, {
                        dataSource: posts,
                        locale: {
                            emptyText: "\u6682\u65E0\u6570\u636E"
                        },
                        loading: loading,
                        renderItem: function(value) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                                url: (0,blog.getPostUrlBySlug)(value.slug),
                                title: value.title,
                                summary: value.summary,
                                status: isShowStatusBadge ? value.status : undefined,
                                metadataStart: /*#__PURE__*/ (0,jsx_runtime.jsxs)(space/* default */.Z, {
                                    size: 24,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EyeOutlined/* default */.Z, {}),
                                                " ",
                                                value.visits
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeartOutlined/* default */.Z, {}),
                                                " ",
                                                value.likes
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageOutlined/* default */.Z, {}),
                                                " ",
                                                value.comments
                                            ]
                                        })
                                    ]
                                }),
                                metadataEnd: /*#__PURE__*/ (0,jsx_runtime.jsx)(MetadataEnd, {
                                    value: value
                                })
                            }, value.id);
                        }
                    })
                })
            })
        ]
    });
};
function MetadataEnd(param) {
    var value = param.value;
    var status = value.status;
    var datetime;
    switch(status){
        case "PUBLISHED":
            datetime = value.publishedAt;
            break;
        case "DRAFT":
            datetime = value.createdAt;
            break;
        case "PENDING":
            datetime = value.lastModifiedAt;
            break;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: datetime !== undefined ? (0,datetime_utils/* getRelativeDatetime */.o)(datetime) : ""
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7427,8654,2458,9774,2888,179], function() { return __webpack_exec__(16339); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);